import { Context, ResponsePayload } from "types";

export const getAppointment =
  ({ apiClient }: Context) =>
  (id: string) =>
    apiClient<
      ResponsePayload<App.Domain.API.OnlineAppointments.Resources.AppointmentResource>
    >({
      url: `/online-appointment/confirm/${id}`,
      method: "GET",
    });

export const confirmAppointment =
  ({ apiClient }: Context) =>
  (id: string) =>
    apiClient<
      ResponsePayload<App.Domain.API.OnlineAppointments.Resources.AppointmentPaymentResource>
    >({
      url: `/online-appointment/confirm/${id}`,
      method: "POST",
    });
